module.exports = __webpack_public_path__ + "img/harvestjoy.6546704e.png";